import React from 'react'
import { Outlet } from 'react-router-dom'
import { Result, Button } from 'antd'
import { authStore } from '@/context/auth'
import { useMasterData } from '@/context/MasterDataContext'
import { hasModulePermission, type ModuleName } from '@/utils/permissions'

// Gates a group of routes behind a Role Master module's "view" permission.
// ProtectedRoute already checks "is logged in" — this adds "is this user's
// role actually allowed to see this module", which nothing previously
// checked (a user could reach /master/roles or any other page just by
// knowing the URL, regardless of their assigned role's permissions).
const RequirePermission: React.FC<{ module: ModuleName }> = ({ module }) => {
  const { roles } = useMasterData()
  const user = authStore.getUser()

  if (hasModulePermission(user, roles, module, 'view')) return <Outlet />

  return (
    <Result
      status="403"
      title="Access restricted"
      subTitle="Your role doesn't have permission to view this section. Contact your administrator if you believe this is a mistake."
      extra={
        <Button type="primary" onClick={() => window.history.back()}>
          Go back
        </Button>
      }
    />
  )
}

export default RequirePermission
